import RpmScatterChart from "./RpmScatterChart"

export default  RpmScatterChart;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickFocus/RpmDataModal/RpmTabChart/RpmScatterChart/index.js